import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delete-source-value',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss'],
})
export class DeleteSourceValueComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
